import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { NOT_AVAILABLE } from '../../common/constants/template.constant';
import { DemurrageDetentionStatusEnum } from '../../store/state/monitoring/models/shipment-common-models/demurrage-detention-status.model';

@Component({
  selector: 'ui-demurrage-detention-status',
  imports: [CommonModule, IntrackFeatureModule, TranslateModule],
  templateUrl: './demurrage-detention-status.component.html',
  styleUrls: ['./demurrage-detention-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemurrageDetentionStatusComponent {
  @Input() status: DemurrageDetentionStatusEnum | null = null;
  @Input() size = 20;
  @Input() notAvailableTooltip = '';
  @Input() forceNotAvailable = false;
  readonly demurrageDetentionStatus = DemurrageDetentionStatusEnum;
  readonly notAvailable: string = NOT_AVAILABLE;

  get displayStatus(): DemurrageDetentionStatusEnum | null {
    return this.forceNotAvailable || this.status === null ? DemurrageDetentionStatusEnum.NotAvailable : this.status;
  }
}
